import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-stripes-header",
  "use": "icon-stripes-header-usage",
  "viewBox": "0 0 77 72",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 77 72\" id=\"icon-stripes-header\">\r\n  <text id=\"icon-stripes-header__\" data-name=\"/// \" fill=\"rgba(30,34,170,0.3)\" font-size=\"60\" font-family=\"NHaasGroteskDSPro-45Lt, Neue Haas Grotesk Display Pro\" letter-spacing=\"0.014em\"><tspan x=\"0\" y=\"56\">/</tspan><tspan y=\"56\" fill=\"rgba(30,34,170,0.6)\" font-family=\"NHaasGroteskDSPro-65Md, Neue Haas Grotesk Display Pro\" font-weight=\"500\">/</tspan><tspan y=\"56\" fill=\"#1e22aa\" font-family=\"NHaasGroteskDSPro-75Bd, Neue Haas Grotesk Display Pro\">/</tspan><tspan y=\"56\" fill=\"#333f48\" font-family=\"NHaasGroteskDSPro-65Md, Neue Haas Grotesk Display Pro\" font-weight=\"500\"> </tspan></text>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/stripes-header.svg
// module id = IHca
// module chunks = 14